import { assignDocuments } from 'src/types';
import AbstractApiService from 'src/services/abstractApiService';
import { DocumentListSDKWrapper } from 'src/sdk/api/wrapper/DocumentListSDKWrapper';

export default class DocumentListApiService extends AbstractApiService {
  // Enable SDK routing
  protected useSdk = true;
  protected sdkWrapper = new DocumentListSDKWrapper();

  public constructor() {
    super({});
  }

  public async getListFromWarehouse(query: string): Promise<any> {
    return this.sdkWrapper.getListFromWarehouse(query);
  }

  public async fetchOpendGroupsData(queryStrings: string[]): Promise<any> {
    return this.sdkWrapper.fetchOpendGroupsData(queryStrings);
  }

  public async getList(query: string): Promise<any> {
    return this.sdkWrapper.getList(query);
  }

  public async exportDashboardData(query: string, type: string): Promise<any> {
    return this.sdkWrapper.exportDashboardData(query, type);
  }

  public async uploadFiles(formData: FormData, subOrgId = ''): Promise<any> {
    return this.sdkWrapper.uploadFiles(formData, subOrgId);
  }

  async assignDocuments(data: assignDocuments): Promise<any> {
    return this.sdkWrapper.assignDocuments(data);
  }

  async getTasksState(): Promise<any> {
    return this.sdkWrapper.getTasksState();
  }

  async getPendingTasksCount(): Promise<any> {
    return this.sdkWrapper.getPendingTasksCount();
  }

  /**
   * DB-truth pending DOCUMENTS count for the user header.
   * See DocumentListSDKWrapper.getPendingDocumentsCount for why
   * this exists alongside the queue-depth getPendingTasksCount.
   */
  async getPendingDocumentsCount(): Promise<any> {
    return this.sdkWrapper.getPendingDocumentsCount();
  }

  async restartDocuments(doc_ids: string, force_restart = false): Promise<any> {
    return this.sdkWrapper.restartDocuments(doc_ids, force_restart);
  }

  async restartExportDocuments(
    doc_ids: string,
    force_restart = false,
  ): Promise<any> {
    return this.sdkWrapper.restartExportDocuments(doc_ids, force_restart);
  }

  restartExport(doc_id: string, force_restart = false, restart_from_failed = false): Promise<any> {
    return this.sdkWrapper.restartExport(doc_id, force_restart, restart_from_failed);
  }

  restartDocument(docId: string, force_restart = false): Promise<any> {
    return this.sdkWrapper.restartDocument(docId, force_restart);
  }

  public async uploadFilesForValidation(formData: FormData): Promise<any> {
    return this.sdkWrapper.uploadFilesForValidation(formData);
  }

  getDuplicateInvoices(querystring: string): Promise<any> {
    return this.sdkWrapper.getDuplicateInvoices(querystring);
  }
}
